import { useEffect, useState } from 'react';
import { collection, query, where, onSnapshot } from 'firebase/firestore';
import { firestore } from '../utils/firebase';

export function useUserNotifications(userEmail) {
  const [notifications, setNotifications] = useState([]);

  useEffect(() => {
    if (!userEmail) return;
    const q = query(
      collection(firestore, 'offers'),
      where('userEmail', '==', userEmail)
    );
    const unsub = onSnapshot(q, (snapshot) => {
      const notifs = [];
      snapshot.forEach(doc => {
        const data = doc.data();
        // Find messages from admin/staff that are not seen
        const unseen = (data.messages || []).filter(
          m => m.user !== userEmail && !m.seenByUser
        );
        if (unseen.length > 0) {
          notifs.push({ ...data, id: doc.id, unseen });
        }
      });
      setNotifications(notifs);
    });
    return () => unsub();
  }, [userEmail]);

  return notifications;
}